(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      /* 2026-09-23 (PERF-R2): --header-height ResizeObserver-ით. ადრე აქ სინქრონულად იკითხებოდა
         offsetHeight — სკრიპტის შესრულებისას მთელი გვერდის layout იძულებით ითვლებოდა
         (PSI „Forced reflow“, ~220 ms მობილურზე). RO-ს callback layout-ის შემდეგ მოდის, ზომა
         უკვე გამოთვლილია და ჰედერის სიმაღლის ყოველ ცვლილებაზე (ფონტი, ბრეიქპოინტი) თავად განახლდება.
         ცვლადს მხოლოდ base.css იყენებს (სქროლზე დამალული ჰედერის top). */
      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver((entries) => {
          const box = entries[0] && entries[0].borderBoxSize && entries[0].borderBoxSize[0];
          this.setHeaderHeight(box ? Math.round(box.blockSize) : undefined);
        });
        this.headerResizeObserver.observe(this.header);
      } else {
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', () => this.setHeaderHeight());
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight(height) {
      const value = typeof height === 'number' ? height : this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${value}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.querySelector('.pp-mobile-menu[open], .ppm-menu[open], .pp-search-popup:not([hidden])')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.top-products').forEach(function(sec){
    var track   = sec.querySelector('[id^=tp-track]');
    var slider  = sec.querySelector('[id^=tp-slider]');
    var btnPrev = sec.querySelector('[data-tp-prev]');
    var btnNext = sec.querySelector('[data-tp-next]');
    if(!track) return;

    var pos=0, drag={on:false,startX:0,startPos:0};

    function cardWidth(){
      var c=track.querySelector('.tp-card');
      if(!c)return 0;
      var gap=parseFloat(getComputedStyle(track).gap)||20;
      return c.getBoundingClientRect().width+gap;
    }
    function maxPos(){
      return Math.max(0, track.scrollWidth - slider.getBoundingClientRect().width);
    }
    function clamp(v){ return Math.min(Math.max(v,0),maxPos()); }
    function setPos(v){
      pos=clamp(v);
      track.style.transform='translateX(-'+pos+'px)';
      if(btnPrev) btnPrev.disabled = pos<=0;
      if(btnNext) btnNext.disabled = pos>=maxPos()-1;
    }

    if(btnPrev) btnPrev.addEventListener('click',function(){ setPos(pos-cardWidth()); });
    if(btnNext) btnNext.addEventListener('click',function(){ setPos(pos+cardWidth()); });

    /* touch / mouse drag */
    function dragStart(x){ drag={on:true,startX:x,startPos:pos}; slider.classList.add('is-dragging'); }
    function dragMove(x){
      if(!drag.on)return;
      setPos(drag.startPos-(x-drag.startX));
    }
    function dragEnd(){ drag.on=false; slider.classList.remove('is-dragging'); }

    slider.addEventListener('mousedown', function(e){ dragStart(e.clientX); });
    window.addEventListener('mousemove',  function(e){ dragMove(e.clientX); });
    window.addEventListener('mouseup',   dragEnd);

    slider.addEventListener('touchstart', function(e){ dragStart(e.touches[0].clientX); },{passive:true});
    slider.addEventListener('touchmove',  function(e){ dragMove(e.touches[0].clientX); },{passive:true});
    slider.addEventListener('touchend',  dragEnd);

    setPos(0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
